export default __webpack_public_path__ + "static/media/bg2.bc4787b7.jpg";